export default __webpack_public_path__ + "static/media/notification-empty.da95454c.svg";